<script>
    import {onMount} from 'svelte';
    import TopMenu from '../components/TopMenu.svelte';
    import TopMenu_AddBtn from '../components/TopMenu_AddBtn.svelte';
    import Header from '../components/Header.svelte';
    import {api, api_formdata, store} from '../stores.js';
    
    const user = store('credentials', 'appUserAuth');
    const detach = (node) => node ? node.parentNode.removeChild(node) : null;

    let wrapper;
    let product = '';
    let id = '';
    let type = '';
    let list;
    let params = {};
    let steps = {};
    let variants = {};
    let b64 = '';
    let json = '';
    
    onMount(() => {
        params = {
            2: detach(list.querySelector('[data-params-type="2"]')),
            5: detach(list.querySelector('[data-params-type="5"]')),
            6: detach(list.querySelector('[data-params-type="6"]')),
            7: detach(list.querySelector('[data-params-type="7"]')),
        };
        steps = {
            6: detach(list.querySelector('[data-steps-type="6"]')),
        };
        variants = {
            1: detach(list.querySelector('[data-option-type="1"]')),
            2: detach(list.querySelector('[data-option-type="2"]')),
            3: detach(list.querySelector('[data-option-type="3"]')),
            4: detach(list.querySelector('[data-option-type="4"]')),
            5: detach(list.querySelector('[data-option-type="5"]')),
            6: detach(list.querySelector('[data-option-type="6"]')),
            7: detach(list.querySelector('[data-option-type="7"]')),
        };
    });
    
    const changeType = () => {
        list.innerHTML = '';
    
        let node;
        if (type && params[type]) {
            node = params[type].cloneNode(true);
            node.querySelectorAll('[data-step-add]').forEach(el => {el.onclick = handlerAddStep;});
            
            list.appendChild(node);
        }
        id = Math.random().toString(36).replace(/[^a-z]+/g, '').substr(0, 8);
        
        handlerAddVariant();
    };
    const handlerAddVariant = () => {
        let node
        if (type) {
            node = variants[type].cloneNode(true);
            node.querySelector('button.btn-danger').onclick = handlerRemoveVariant;
            node.querySelectorAll('input[type="file"]').forEach(el => {el.onchange = loadFiles;});
            
            list.appendChild(node);
        }
        renderStruct();
    };
    const handlerRemoveVariant = (e) => {
        let node = e.target.closest('[data-option-type]');
        
        node.parentNode.removeChild(node);
        renderStruct();
    };
    
    const loadFiles = async (e) => {
        let holder = e.target.parentNode.parentNode.querySelector('input[type="text"][name="' + e.target.name + '"]');
        let fd = new FormData();
            fd.append('files[image]', e.target.files[0]);

        let response = await api_formdata('load_file', fd);
    
        if (response && response.params.data && response.data.image) {
            holder.value = 'https://225304.selcdn.ru/miin/' + response.data.image;
            renderStruct();
        }
    };
    
    const handlerAddStep = () => {
        let node
        if (type && steps[type]) {
            node = steps[type].cloneNode(true);
            node.querySelector('button.btn-danger').onclick = handlerRemoveStep;
            list.insertBefore(node, list.querySelector('[data-option-type]'));
        }
        renderStruct();
    };
    const handlerRemoveStep = (e) => {
        let node = e.target.closest('[data-steps-type]');
    
        node.parentNode.removeChild(node);
        renderStruct();
    };
    
    const renderStruct = () => {
        let params = {},
            steps = [],
            options = [],
            bonus = 0;
        
        // параметры
        list.querySelectorAll('[data-params-type="' + type + '"]').forEach((item) => {
            item.querySelectorAll('input, textarea, select').forEach((inp) => {
                if (inp.value) {
                    params[inp.name] = inp.value;
                }
            });
        });
        
        // пороги
        list.querySelectorAll('[data-steps-type="' + type + '"]').forEach((item) => {
            let step = {};
    
            item.querySelectorAll('input:not([type="file"]), textarea, select').forEach((inp) => {
                if (inp.value) {
                    step[inp.name] = inp.value;
                }
            });
    
            steps.push(step);
        });
        
        // опции
        list.querySelectorAll('[data-option-type="' + type + '"]').forEach((item) => {
            let option = {};
    
            item.querySelectorAll('input:not([type="file"]), textarea, select').forEach((inp) => {
                if (inp.value) {
                    option[inp.name] = inp.value;
                    bonus += +(inp.name === 'bonus' ? inp.value : 0);
                }
            });
    
            options.push(option);
        });
        
        let map = {id};

        if (product) {
            map.product = product;
        }
        if (type) {
            map.type = type;
        }
        if (bonus) {
            map.reward = bonus;
        }
        if (Object.keys(params).length) {
            map.params = params;
        }
        if (steps.length) {
            map.steps = steps;
        }
        if (options.length) {
            map.options = options;
        }
        
        b64 = btoa(unescape(encodeURIComponent(JSON.stringify(map))));
    };

    const fetchProductList = (async () => {
        let result = await api('getProductList');
        return result.data ? result.data : [];
    })();
    
    const handlerPasteB64 = () => {
        let data = parseB64Code(b64);
        json = JSON.stringify(data, null, 4);
        wrapper.querySelector('[data-json]').style.display = 'block';
    };
    
    const handlerChangeJSON = () => {
        let data = JSON.parse(json);
        b64 = btoa(unescape(encodeURIComponent(JSON.stringify(data))));
    };
</script>

<TopMenu title="Редактор">
    <TopMenu_AddBtn slot="right" on:click={handlerAddVariant} />
</TopMenu>

<div id="appCapsule">
    <Header title="Редактор" />
    
    <div class="section mt-1 mb-5" bind:this={wrapper}>
        <form>
            <div class="row">
                <div class="col-12 col-lg-7">
    
                    <div class="row mb-2">
                        <div class="col-12 col-md-4">
                            <div class="form-group boxed">
                                <div class="input-wrapper">
                                    <label class="form-label">Тип опроса <span class="text-danger">*</span></label>
                                    <select class="form-control form-select" name="form[type]" bind:value={type} on:change={changeType} required>
                                        <option value="1">правда или миф</option>
                                        <option value="2">выбор из двух картинок</option>
                                        <option value="3">расставить по возрастанию</option>
                                        <option value="4">выбор из пары</option>
                                        <option value="5">что на картинке</option>
                                        <option value="6">тестирование</option>
                                        <option value="7">какой ты персонаж</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div class="col-12 col-md-5">
                            <div class="form-group boxed">
                                <div class="input-wrapper">
                                    <label class="form-label" for="produkt">Продукт <span class="text-danger">*</span></label>
                                    {#await fetchProductList}
                                        <select class="form-control form-select">
                                            <option value="null" selected disabled>Загрузка</option>
                                        </select>
                                    {:then data}
                                        <select class="form-control form-select" id="produkt" name="produkt" bind:value={product} on:change={renderStruct} required>
                                            {#each data as {idProd, naimenovanie}}
                                                <option value="{idProd}">{naimenovanie}</option>
                                            {/each}
                                        </select>
                                    {/await}
                                </div>
                            </div>
                        </div>
                        <div class="col-6 col-md-2">
                            <button type="button" class="btn btn-primary btn-icon w-100" style="margin-top: 29px;" on:click={handlerAddVariant}>
                                <ion-icon name="add" role="img" class="md hydrated" aria-label="add"></ion-icon>
                            </button>
                        </div>
                        <div class="col-6 col-md-1">
                            <button type="button" class="btn btn-secondary btn-icon w-100" style="margin-top: 29px;" data-bs-toggle="modal" data-bs-target="#modal-help">
                                <ion-icon name="help-outline"></ion-icon>
                            </button>
                        </div>
                    </div>
                    
                    <div class="mb-3" bind:this={list} on:keyup={renderStruct} on:paste={renderStruct} on:change={renderStruct}>
                        <!-- правда или миф -->
                        <div class="row mb-1" data-option-type="1" style="border: 1px dashed #60c370; border-radius: 6px;">
                            <div class="col-11">
                                <div class="form-group boxed">
                                    <div class="input-wrapper">
                                        <label class="form-label">Вопрос <span class="text-danger">*</span></label>
                                        <input type="text" class="form-control" name="label">
                                    </div>
                                </div>
                            </div>
                            <div class="col-1">
                                <button type="button" class="btn btn-danger btn-icon w-100" style="margin-top: 30px;">
                                    <ion-icon name="trash-outline" role="img" class="md hydrated" aria-label="edit"></ion-icon>
                                </button>
                            </div>
                            <div class="col-12 col-md-10">
                                <div class="form-group boxed">
                                    <div class="input-wrapper">
                                        <label class="form-label">Ответ <span class="text-danger">*</span></label>
                                        <select class="form-control form-select" name="answer">
                                            <option value="1">Правда</option>
                                            <option value="0">Миф</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                            <div class="col-12 col-md-2">
                                <div class="form-group boxed">
                                    <div class="input-wrapper">
                                        <label class="form-label">Балл за ответ <span class="text-danger">*</span></label>
                                        <input type="number" class="form-control" name="bonus" value="1">
                                    </div>
                                </div>
                            </div>
                        </div>
                        
                        <!-- выбор из двух картинок -->
                        <div class="row mb-1" data-params-type="2" style="border: 1px dashed #60c370; border-radius: 6px;">
                            <div class="col-6">
                                <div class="form-group boxed">
                                    <div class="input-wrapper">
                                        <label class="form-label">Кнопка 1</label>
                                        <input type="text" class="form-control" name="button_1" placeholder="Слева">
                                    </div>
                                </div>
                            </div>
                            <div class="col-6">
                                <div class="form-group boxed">
                                    <div class="input-wrapper">
                                        <label class="form-label">Кнопка 2</label>
                                        <input type="text" class="form-control" name="button_2" placeholder="Справа">
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row mb-1" data-option-type="2" style="border: 1px dashed #60c370; border-radius: 6px;">
                            <div class="col-11">
                                <div class="form-group boxed">
                                    <div class="input-wrapper">
                                        <label class="form-label">Вопрос</label>
                                        <input type="text" class="form-control" name="label">
                                    </div>
                                </div>
                            </div>
                            <div class="col-1">
                                <button type="button" class="btn btn-danger btn-icon w-100" style="margin-top: 30px;">
                                    <ion-icon name="trash-outline" role="img" class="md hydrated" aria-label="edit"></ion-icon>
                                </button>
                            </div>
                            
                            <div class="col-12">
                                <div class="form-group boxed">
                                    <div class="input-wrapper">
                                        <label class="form-label">Картинка 1 <span class="text-danger">*</span></label>
                                        <div class="row">
                                            <div class="col-8">
                                                <input type="text" class="form-control" name="image_1" placeholder="http://">
                                            </div>
                                            <div class="col-4">
                                                <input type="file" class="form-control" style="height: 42px; background-color: rgb(233, 236, 239);" name="image_1" accept=".png, .jpg, .jpeg">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-12">
                                <div class="form-group boxed">
                                    <div class="input-wrapper">
                                        <label class="form-label">Подпись к картинке 1</label>
                                        <input type="text" class="form-control" name="description_1">
                                    </div>
                                </div>
                            </div>
                            <div class="col-12">
                                <div class="form-group boxed">
                                    <div class="input-wrapper">
                                        <label class="form-label">Картинка 2 <span class="text-danger">*</span></label>
                                        <div class="row">
                                            <div class="col-8">
                                                <input type="text" class="form-control" name="image_2" placeholder="http://">
                                            </div>
                                            <div class="col-4">
                                                <input type="file" class="form-control" style="height: 42px; background-color: rgb(233, 236, 239);" name="image_2" accept=".png, .jpg, .jpeg">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-12">
                                <div class="form-group boxed">
                                    <div class="input-wrapper">
                                        <label class="form-label">Подпись к картинке 2</label>
                                        <input type="text" class="form-control" name="description_2">
                                    </div>
                                </div>
                            </div>
                            <div class="col-12 text-small text-muted">
                                <u>Примечание</u>: для лучшего вида - необходимо чтобы картинки были одного размера
                            </div>
                            
                            <div class="col-12 col-md-10">
                                <div class="form-group boxed">
                                    <div class="input-wrapper">
                                        <label class="form-label">Ответ <span class="text-danger">*</span></label>
                                        <select class="form-control form-select" name="answer">
                                            <option value="1">Картинка 1</option>
                                            <option value="2">Картинка 2</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                            <div class="col-12 col-md-2">
                                <div class="form-group boxed">
                                    <div class="input-wrapper">
                                        <label class="form-label">Балл за ответ <span class="text-danger">*</span></label>
                                        <input type="number" class="form-control" name="bonus" value="1">
                                    </div>
                                </div>
                            </div>
                        </div>
    
                        <!-- расставить по возрастанию -->
                        <div class="row mb-1" data-option-type="3" style="border: 1px dashed #60c370; border-radius: 6px;">
                            <div class="col-11">
                                <div class="form-group boxed">
                                    <div class="input-wrapper">
                                        <label class="form-label">Вопрос <span class="text-danger">*</span></label>
                                        <input type="text" class="form-control" name="label">
                                    </div>
                                </div>
                            </div>
                            <div class="col-1">
                                <button type="button" class="btn btn-danger btn-icon w-100" style="margin-top: 30px;">
                                    <ion-icon name="trash-outline" role="img" class="md hydrated" aria-label="edit"></ion-icon>
                                </button>
                            </div>
                            <div class="col-12 col-md-10">
                                <div class="form-group boxed">
                                    <div class="input-wrapper">
                                        <label class="form-label">Значение <span class="text-danger">*</span></label>
                                        <input type="number" class="form-control" name="value" value="1">
                                    </div>
                                </div>
                            </div>
                            <div class="col-12 col-md-2">
                                <div class="form-group boxed">
                                    <div class="input-wrapper">
                                        <label class="form-label">Балл за ответ <span class="text-danger">*</span></label>
                                        <input type="number" class="form-control" name="bonus" value="1">
                                    </div>
                                </div>
                            </div>
                        </div>
    
                        <!-- правильная пара -->
                        <div class="row mb-1" data-option-type="4" style="border: 1px dashed #60c370; border-radius: 6px;">
                            <div class="col-11">
                                <div class="form-group boxed">
                                    <div class="input-wrapper">
                                        <label class="form-label">Вопрос</label>
                                        <input type="text" class="form-control" name="label">
                                    </div>
                                </div>
                            </div>
                            <div class="col-1">
                                <button type="button" class="btn btn-danger btn-icon w-100" style="margin-top: 30px;">
                                    <ion-icon name="trash-outline" role="img" class="md hydrated" aria-label="edit"></ion-icon>
                                </button>
                            </div>
    
                            <div class="col-6">
                                <div class="form-group boxed">
                                    <div class="input-wrapper">
                                        <label class="form-label">Вариант 1</label>
                                        <input type="text" class="form-control" name="variant_1">
                                    </div>
                                </div>
                            </div>
                            <div class="col-6">
                                <div class="form-group boxed">
                                    <div class="input-wrapper">
                                        <label class="form-label">Значение для 1 варианта</label>
                                        <input type="number" class="form-control" name="variant_1_value">
                                    </div>
                                </div>
                            </div>
    
                            <div class="col-6">
                                <div class="form-group boxed">
                                    <div class="input-wrapper">
                                        <label class="form-label">Вариант 2</label>
                                        <input type="text" class="form-control" name="variant_2">
                                    </div>
                                </div>
                            </div>
                            <div class="col-6">
                                <div class="form-group boxed">
                                    <div class="input-wrapper">
                                        <label class="form-label">Значение для 2 варианта</label>
                                        <input type="number" class="form-control" name="variant_2_value">
                                    </div>
                                </div>
                            </div>
                            
                            <div class="col-12 col-md-10">
                                <div class="form-group boxed">
                                    <div class="input-wrapper">
                                        <label class="form-label">Ответ <span class="text-danger">*</span></label>
                                        <select class="form-control form-select" name="answer">
                                            <option value="1">Значение 1</option>
                                            <option value="2">Значение 2</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                            <div class="col-12 col-md-2">
                                <div class="form-group boxed">
                                    <div class="input-wrapper">
                                        <label class="form-label">Балл за ответ <span class="text-danger">*</span></label>
                                        <input type="number" class="form-control" name="bonus" value="1">
                                    </div>
                                </div>
                            </div>
                        </div>
    
                        <!-- что на картинке -->
                        <div class="row mb-1" data-params-type="5" style="border: 1px dashed #60c370; border-radius: 6px;">
                            <div class="col-4">
                                <div class="form-group boxed">
                                    <div class="input-wrapper">
                                        <label class="form-label">Кнопка 1</label>
                                        <input type="text" class="form-control" name="button_1" placeholder="Завтрак, ПРОСТЫЕ, БЕЛОК">
                                    </div>
                                </div>
                            </div>
                            <div class="col-4">
                                <div class="form-group boxed">
                                    <div class="input-wrapper">
                                        <label class="form-label">Кнопка 2</label>
                                        <input type="text" class="form-control" name="button_2" placeholder="Обед, СЛОЖНЫЕ, НЕ БЕЛОК">
                                    </div>
                                </div>
                            </div>
                            <div class="col-4">
                                <div class="form-group boxed">
                                    <div class="input-wrapper">
                                        <label class="form-label">Кнопка 3</label>
                                        <input type="text" class="form-control" name="button_3" placeholder="Ужин">
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row mb-1" data-option-type="5" style="border: 1px dashed #60c370; border-radius: 6px;">
                            <div class="col-11">
                                <div class="form-group boxed">
                                    <div class="input-wrapper">
                                        <label class="form-label">Вопрос</label>
                                        <input type="text" class="form-control" name="label">
                                    </div>
                                </div>
                            </div>
                            <div class="col-1">
                                <button type="button" class="btn btn-danger btn-icon w-100" style="margin-top: 30px;">
                                    <ion-icon name="trash-outline" role="img" class="md hydrated" aria-label="edit"></ion-icon>
                                </button>
                            </div>
        
                            <div class="col-12">
                                <div class="form-group boxed">
                                    <div class="input-wrapper">
                                        <label class="form-label">Картинка <span class="text-danger">*</span></label>
                                        <div class="row">
                                            <div class="col-8">
                                                <input type="text" class="form-control" name="image_1" placeholder="http://">
                                            </div>
                                            <div class="col-4">
                                                <input type="file" class="form-control" style="height: 42px; background-color: rgb(233, 236, 239);" name="image_1" accept=".png, .jpg, .jpeg">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
    
                            <div class="col-12">
                                <div class="form-group boxed">
                                    <div class="input-wrapper">
                                        <label class="form-label">Подпись к картинке</label>
                                        <input type="text" class="form-control" name="description">
                                    </div>
                                </div>
                            </div>
        
                            <div class="col-12 col-md-10">
                                <div class="form-group boxed">
                                    <div class="input-wrapper">
                                        <label class="form-label">Ответ <span class="text-danger">*</span></label>
                                        <select class="form-control form-select" name="answer">
                                            <option value="1">Кнопка 1</option>
                                            <option value="2">Кнопка 2</option>
                                            <option value="3">Кнопка 3</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                            <div class="col-12 col-md-2">
                                <div class="form-group boxed">
                                    <div class="input-wrapper">
                                        <label class="form-label">Балл за ответ <span class="text-danger">*</span></label>
                                        <input type="number" class="form-control" name="bonus" value="1">
                                    </div>
                                </div>
                            </div>
                        </div>
                        
                        <!-- тестирование -->
                        <div class="row mb-1" data-params-type="6">
                            <div class="col-12 text-center">
                                <button type="button" data-step-add class="btn btn-secondary btn-block">
                                    Добавить порог Баллов
                                </button>
                            </div>
                        </div>
                        <div class="row mb-1" data-steps-type="6" style="border: 1px dashed #6C7C94; border-radius: 6px;">
                            <div class="col-2">
                                <div class="form-group boxed">
                                    <div class="input-wrapper">
                                        <label class="form-label">Баллов от</label>
                                        <input type="number" class="form-control" name="bonus_from">
                                    </div>
                                </div>
                            </div>
                            <div class="col-2">
                                <div class="form-group boxed">
                                    <div class="input-wrapper">
                                        <label class="form-label">Баллов до</label>
                                        <input type="number" class="form-control" name="bonus_to">
                                    </div>
                                </div>
                            </div>
                            <div class="col-7"></div>
                            <div class="col-1">
                                <button type="button" class="btn btn-danger btn-icon w-100" style="margin-top: 30px;">
                                    <ion-icon name="trash-outline" role="img" class="md hydrated" aria-label="edit"></ion-icon>
                                </button>
                            </div>
                            <div class="col-11">
                                <div class="form-group boxed">
                                    <div class="input-wrapper">
                                        <label class="form-label">Комментарий</label>
                                        <textarea class="form-control" name="comment"></textarea>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row mb-1" data-option-type="6" style="border: 1px dashed #60c370; border-radius: 6px;">
                            <div class="col-11">
                                <div class="form-group boxed">
                                    <div class="input-wrapper">
                                        <label class="form-label">Вопрос</label>
                                        <input type="text" class="form-control" name="label">
                                    </div>
                                </div>
                            </div>
                            <div class="col-1">
                                <button type="button" class="btn btn-danger btn-icon w-100" style="margin-top: 30px;">
                                    <ion-icon name="trash-outline" role="img" class="md hydrated" aria-label="edit"></ion-icon>
                                </button>
                            </div>
                            <div class="col-12 col-md-10">
                                <div class="form-group boxed">
                                    <div class="input-wrapper">
                                        <label class="form-label">Ответ <span class="text-danger">*</span></label>
                                        <select class="form-control form-select" name="answer">
                                            <option value="1">Да</option>
                                            <option value="0">Нет</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                            <div class="col-12 col-md-2">
                                <div class="form-group boxed">
                                    <div class="input-wrapper">
                                        <label class="form-label">Балл за ответ <span class="text-danger">*</span></label>
                                        <input type="number" class="form-control" name="bonus" value="1">
                                    </div>
                                </div>
                            </div>
                        </div>
                        
                        <!-- какой ты персонаж -->
                        <div class="row mb-1" data-params-type="7">
                            <div class="col-12 text-center">
                                <div class="form-group boxed">
                                    <div class="input-wrapper">
                                        <label class="form-label">Тип игры <span class="text-danger">*</span></label>
                                        <select class="form-control form-select" name="type" bind:value={type} on:change={changeType} required>
                                            <option value="1">Один выбранный вариант</option>
                                            <option value="2">Все выбранные варианты</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row mb-1" data-option-type="7" style="border: 1px dashed #60c370; border-radius: 6px;">
                            <div class="col-11">
                                <div class="form-group boxed">
                                    <div class="input-wrapper">
                                        <label class="form-label">Имя персонажа</label>
                                        <input type="text" class="form-control" name="character">
                                    </div>
                                </div>
                            </div>
                            <div class="col-1">
                                <button type="button" class="btn btn-danger btn-icon w-100" style="margin-top: 30px;">
                                    <ion-icon name="trash-outline" role="img" class="md hydrated" aria-label="edit"></ion-icon>
                                </button>
                            </div>
                            <div class="col-11">
                                <div class="form-group boxed">
                                    <div class="input-wrapper">
                                        <label class="form-label">Варианты ответа</label>
                                        <input type="text" class="form-control" name="match" placeholder="Красный; Синий; Желтый">
                                    </div>
                                </div>
                            </div>
                            <div class="col-11 text-small text-muted">
                                <u>Примечание</u>: указывать значение через символ делителя (<code>;</code>), количество не ограничено.
                            </div>
                        </div>
                    </div>
                    
                    <!-- модальное окно с инструкцией -->
                    <div class="modal fade modalbox" id="modal-help" data-bs-backdrop="static" tabindex="-1" role="dialog">
                        <div class="modal-dialog" role="document">
                            <div class="modal-content">
                                <div class="modal-header">
                                    <h5 class="modal-title">Инструкция</h5>
                                    <a href="#" data-bs-dismiss="modal">Закрыть</a>
                                </div>
                                <div class="modal-body">
                                    <h4 class="mb-0">Опрос</h4>
                                    <h5 class="mt-1 mb-0">Правда или миф</h5>
                                    <p class="mb-0">
                                        Опрос подразумевает наличие <u>вопроса</u> и две кнопки <u>правда</u> и <u>миф</u>.<br>
                                        Необходимо заполнить поле <u>вопрос</u> и отметить правильную кнопку для ответа в поле <u>ответ</u>.<br>
                                        При необходимости можно указать <u>балл</u> за правильный ответ.
                                    </p>
                                    <h5 class="mt-1 mb-0">Выбор из двух картинок</h5>
                                    <p class="mb-0">
                                        Каждый вопрос показывает участнику две картинки и две кнопки.<br>
                                        Для начала заполняются, общие для опроса, названия кнопок <u>кнопка 1</u> и <u>кнопка 2</u>.
                                        Затем, по желанию, указывается <u>вопрос</u> и выбраются картинки (<u>картинка 1</u> и <u>картинка 2</u>) с компьютера или из сети интернет, в конце требуется указать правильный ответ.<br>
                                        При необходимости можно указать <u>балл</u> за правильный ответ.
                                    </p>
                                    <h5 class="mt-1 mb-0">Расставить по возрастанию</h5>
                                    <p class="mb-0">
                                        Участник должен расставить предметы по возрастанию значения.<br>
                                        Имя предмета указывается в поле <u>вопрос</u>, а в поле <u>значение</u> указывается числовое значение соответствующее предмету.<br>
                                        Указанный <u>балл</u> за правильный ответ начисляется при правильной расстановке всех предметов.
                                    </p>
                                    <h5 class="mt-1 mb-0">Выбор из пары</h5>
                                    <p class="mb-0">
                                        Участнику необходимо выбрать в каком из двух предметов значение больше.<br>
                                        Имя предметов указывается в поля <u>вариант 1</u> и <u>вариант 2</u>, а в поля <u>значение для N варианта</u> указывается числовое значение соответственно. В поле <u>ответ</u> необходимо выбрать правильный вариант<br>
                                        При необходимости можно указать <u>балл</u> за правильный ответ.
                                    </p>
                                    <h5 class="mt-1 mb-0">Что на картинке</h5>
                                    <p class="mb-0">
                                        Каждый вопрос показывает участнику одну картинку и две кнопки или три кнопки.<br>
                                        Для начала заполняются общие для опроса, названия кнопок <u>кнопка 1</u>, <u>кнопка 2</u> и <u>кнопка 3</u> (если нужно).
                                        Затем, по желанию, указывается <u>вопрос</u> и выбрается <u>картинка</u> с компьютера или из сети интернет, для картинки можно указать <u>подпись к картинке</u>, в конце требуется указать какая кнопка будет правильным ответом.<br>
                                        При необходимости можно указать <u>балл</u> за правильный ответ.
                                    </p>
                                    <h5 class="mt-1 mb-0">Тестирование</h5>
                                    <p class="mb-0">
                                        Опрос состоит из <u>вопроса</u> и двух кнопок <u>да</u> и <u>нет</u>, на основе количества правильных ответов отображается рекомендация.<br>
                                        Необходимо заполнить поле <u>вопрос</u> и отметить правильную кнопку для ответа в поле <u>ответ</u>. За правильный ответ засчитывается <u>балл</u>.<br>
                                        Так же необходимо <u>добавить порог баллов</u>: в поля <u>баллов от</u> и <u>баллов до</u> указывается промежуток зачисленных (за ответы) баллов, в поле <u>комментарий</u> указывается рекомендация.
                                    </p>
                                    <h5 class="mt-1 mb-0">Какой ты персонаж</h5>
                                    <p class="mb-0">
                                        Один выбранный вариант.<br>
                                        Респондент выбирает некоторое количество <u>вариантов</u> из списка, алгоритм подбирает персонажа максимально соответствующего выбору.
                                        Необходимо добавить персонажа и указать ему варианты ответа через символ делителя (<code>;</code>).
                                        Все указанные варианты будут собраны и перемешаны во время прохождения теста.<br><br>

                                        Все выбранные варианты.<br>
                                        Респондент выбирает подходящие <u>варианты</u> и они все сохраняются в результатах теста.
                                    </p>
                                    
                                    <h4 class="mt-3 mb-0">Публикация</h4>
                                    <p class="mb-0">
                                        1. Откройте форму добавления новой <a href="https://form.miin.ru/cup/publication/add" class="btn btn-outline-primary btn-sm" target="_blank">публикации</a><br>
                                        2. Заполните: <u>заголовок</u>, <u>краткое описание</u>, выберете нужную <u>категорию</u> и загрузите картинки для публикации<br>
                                        3. В разделе <u>полное описание</u> найдите и нажмите кнопку <span class="btn btn-outline-secondary btn-sm btn-icon"><ion-icon name="code-slash-outline"></ion-icon></span> для перехода в режим редактирования текста<br>
                                        4. Скопируйте <u>код для публикации</u> и вставьте в поле <u>полное описание</u> без каких-либо изменений<br>
                                        5. Нажмите кнопку <span class="btn btn-outline-secondary btn-sm">Сохранить</span><br>
                                    </p>
                                    
                                    <h4 class="mt-3 mb-0">Редактирование</h4>
                                    <p class="mb-0">
                                        1. Вставьте в поле <u>код для публикации</u> код опроса, который необходимо отредактировать<br>
                                        2. Появится дополнительное поле <u>JSON</u> в котором будет отображен декодированный код опроса<br>
                                        3. Отредактируйте значения; <b>важно(!) сохранять разметку</b><br>
                                        4. Вновь скопируйте <u>код для публикации</u> и вставьте в поле <u>полное описание</u> публикации без каких-либо изменений<br>
                                        5. Нажмите кнопку <span class="btn btn-outline-secondary btn-sm">Сохранить</span><br>
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- !модальное окно с инструкцией -->
                </div>
            </div>
            
            <div class="row">
                <div class="col-12 col-lg-7" data-json style="display: none">
                    <div class="form-group boxed">
                        <div class="input-wrapper">
                            <label class="form-label">JSON</label>
                            <textarea class="form-control border-info" style="width: 100%; height: 180px; resize: none;" bind:value={json} on:keyup={() => setTimeout(handlerChangeJSON, 100)} on:change={() => setTimeout(handlerChangeJSON, 100)}></textarea>
                        </div>
                    </div>
                </div>
                
                <div class="col-12 col-lg-7" data-b64>
                    <div class="form-group boxed">
                        <div class="input-wrapper">
                            <label class="form-label">Код для публикации</label>
                            <textarea class="form-control" style="width: 100%; height: 180px; resize: none;" bind:value={b64} on:paste={() => setTimeout(handlerPasteB64, 100)}></textarea>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </div>
</div>
